import _ from "lodash";
import { HttpService } from "@/core";
import {
  CompanyPageReq,
  CompanyPageRecord,
  CompanySimpleListReq,
  CompanySimpleListResp,
  CompanyDetailResp,
  CompanyReq,
  InvoiceReq,
} from "./company.interface";
import {Company, CompanyContactReq, FileResp} from "@/views/cooperation/company/company-contact.interface";

export class CompanyService {
  static usePageApi() {
    const api = (params: CompanyPageReq) =>{
      if(params['cooperationCompanyTypeIds']){
        if(typeof params['cooperationCompanyTypeIds']=='string'){
          params['cooperationCompanyTypeIds']=[params['cooperationCompanyTypeIds']]
        }
      }
      return HttpService.axios({
        method: "POST",
        url: "/cooperation_company/page",
        data:params,
      });
    }

    return HttpService.usePagination<CompanyPageRecord>(api);
  }

  static useSimpleListApi() {
    const api = (params: CompanySimpleListReq) =>
      HttpService.axios({
        method: "GET",
        url: "/cooperation_company/simple/list",
        params,
      });
    return HttpService.useRequest<CompanySimpleListResp>(api);
  }

  static useDetailApi() {
    const api = (id: string) =>
      HttpService.axios({
        method: "GET",
        url: `/cooperation_company/${id}`,
      });
    return HttpService.useRequest<CompanyDetailResp>(api, {
      formatResult: (resp) => {
        if (resp) {
          // 解析往来单位类别
          resp.cooperationCompanyTypeNames = (resp.cooperationCompanyTypes || []).map(
            (item) => item.cooperationCompanyTypeName
          );
          resp.cooperationCompanyTypeIds = (resp.cooperationCompanyTypes || []).map(
            (item) => item.cooperationCompanyTypeId
          );

          // 解析跟进人
          resp.followTenantUserIds = (resp.followList || []).map((item) => item.tenantUserId);
          resp.followTenantUserNames = (resp.followList || []).map((item) => item.realName);

          // 解析开票资料 支付方式
          resp.invoices = (resp.invoices || []).map((invoice) => {
            invoice.payTypes = (invoice.pays || []).map((item) => item.payType);
            invoice.payNames = (invoice.pays || []).map((item) => item.payTypeShowName);
            invoice.settlementTypes = (invoice.settlementModes || []).map(
              (item) => item.settlement
            );
            invoice.settlementShowNames = (invoice.settlementModes || []).map(
              (item) => item.settlementShowName
            );
            return invoice;
          });
        }
        return resp;
      },
    });
  }

  static useCreateApi() {
    const api = (data: CompanyReq) =>
      HttpService.axios({
        method: "POST",
        url: "/cooperation_company/all",
        data,
      });
    return HttpService.useRequest<{ id: string }>(api);
  }

  static useEditApi() {
    const api = (id: string, data: CompanyReq) =>
      HttpService.axios({
        method: "PUT",
        url: `/cooperation_company/${id}`,
        data,
      });
    return HttpService.useRequest<{ id: string }>(api);
  }
  static useEditContactApi() {
      const api = (id: string, data: CompanyReq) =>
          HttpService.axios({
              method: "post",
              url: `/cooperation_company/updateAll/${id}`,
              data,
          });
      return HttpService.useRequest<{ id: string }>(api);
  }
  static useDeleteApi() {
    const api = (id: string) =>
      HttpService.axios({
        method: "DELETE",
        url: `/cooperation_company/${id}`,
      });
    return HttpService.useRequest<{ id: string }>(api);
  }

  static useStatusApi() {
    const api = (id: string, enable: boolean) =>
      HttpService.axios({
        method: "PUT",
        url: `/cooperation_company/${id}/enable`,
        data: { enable },
      });
    return HttpService.useRequest<{ id: string }>(api);
  }

  static detailRespToCompanyReq(resp: CompanyDetailResp): CompanyReq {
    const companyReq = new CompanyReq();
    companyReq.merge(_.pick(resp, Object.keys(companyReq)));

    // 解析开票资料
    const invoices = (resp.invoices || []).map((invoice) => {
      const invoiceReq = new InvoiceReq();
      invoiceReq.merge(_.pick(invoice, Object.keys(invoiceReq)));
      return invoiceReq;
    });
    companyReq.merge({ invoices });

    return companyReq;
  }

  static useUploadCompany() {
    const api = (url) =>
      HttpService.axios({
        url: "/cooperation_company/importBatchCheck",
        data: {
          url,
        },
        method: "post",
      });
    return HttpService.useRequest<FileResp<Company>>(api);
  }

  static useUploadCompanyWithSource(importSource: number) {
    const api = (url) =>
      HttpService.axios({
        url: "/cooperation_company/importBatchCheckWithSource",
        data: {
          url,
          importSource,
        },
        method: "post",
      });
    return HttpService.useRequest<FileResp<Company>>(api);
  }

  static useFinishUpload() {
    const api = (data) =>
      HttpService.axios({
        url: "/cooperation_company/importBatch",
        data: {
          cooperationCompanyList: data,
        },
        method: "post",
      });
    return HttpService.useRequest<void>(api);
  }

  static useRemoveApi() {
    const api = (ids: string[]) =>
      HttpService.axios({
        method: "POST",
        url: `/cooperation_company/delete/batch`,
				data:{ids}
      });
    return HttpService.useRequest<void>(api);
  }
}
